export function emptyToNull (object) {
  // filtramos objetos/objetos com array
  Object.keys(object).some((k) => {
    // nao podemos ter negacao, ex: !object[k], pois se vier valor 0, vai cair na cond.
    if (object[k] === '' || object[k] === undefined) object[k] = null
    else if (object[k] && typeof object[k] === 'object') emptyToNull(object[k])
  })

  return object
}

export default function validObj (obj, attrs) {
  if (!Array.isArray(attrs)) return false

  var tmp = obj

  for (let i = 0; i < attrs.length; ++i) {
    if (!tmp[attrs[i]]) {
      return null
    }
    tmp = tmp[attrs[i]]
  }

  return tmp || null
}
